import createReactComponent from '../createReactComponent';
export default createReactComponent('hash', 'Hash', [["path",{"d":"M9.697 4 6.678 21M17.054 4l-3.019 17M21 8.781H3m18 7.438H3","key":"svg-0"}]]);